import React, { createContext, useContext, useState, useEffect } from 'react';

// Create a context for debug settings
const DebugContext = createContext();

export function useDebug() {
  return useContext(DebugContext);
}

export function DebugProvider({ children }) {
  // Initialize debug mode from localStorage
  const [debugMode, setDebugMode] = useState(() => {
    return localStorage.getItem('tripsy_debug_mode') === 'true';
  });
  
  // Store original console methods
  const originalConsole = React.useRef({
    log: console.log,
    warn: console.warn,
    error: console.error,
    info: console.info
  });
  
  // Toggle debug mode function
  const toggleDebugMode = () => {
    setDebugMode(prev => !prev);
  };
  
  // Effect to handle console overriding based on debug mode
  useEffect(() => {
    // Override console methods based on debug mode
    if (!debugMode) {
      console.log = () => {};
      console.warn = () => {};
      console.info = () => {};
      // Keep error logs for critical issues
      // console.error = () => {};
    } else {
      // Restore original methods
      console.log = originalConsole.current.log;
      console.warn = originalConsole.current.warn;
      console.info = originalConsole.current.info;
      console.error = originalConsole.current.error;
    }
    
    // Save to localStorage
    localStorage.setItem('tripsy_debug_mode', debugMode);
    
    // Log debugging status change
    if (debugMode) {
      originalConsole.current.log('Debug mode enabled');
    }
    
    // Cleanup function to restore console when component unmounts
    return () => {
      console.log = originalConsole.current.log;
      console.warn = originalConsole.current.warn;
      console.info = originalConsole.current.info;
      console.error = originalConsole.current.error;
    };
  }, [debugMode]);
  
  // Provide the context values to children
  const value = {
    debugMode,
    toggleDebugMode
  };
  
  return (
    <DebugContext.Provider value={value}>
      {children}
    </DebugContext.Provider>
  );
} 